<template>
    <div class="md-layout mt-2">
        <div class="md-layout-item md-size-50">
            <div class="md-multiselect">
                <label>Produit *</label>
                <multiselect v-model="selectedProduct" placeholder="Produit *"
                             label="name" track-by="name" :options="products" :option-height="104"
                             :show-labels="false">
                    <template slot="noOptions">La liste est vide</template>
                    <template slot="noResult">Aucun élement correspondant</template>
                </multiselect>
                <validation-error :errors="apiValidationErrors.newId" />
            </div>
        </div>
        <div class="md-layout-item md-size-20">
            <md-field class="md-invalid">
                <label>Quantité</label>
                <md-input type="number" name="quantity" v-model="quantity" required />
                <validation-error :errors="apiValidationErrors.newQuantity" />
            </md-field>
        </div>
        <div class="md-layout-item md-size-10">
            <div class="flex h-full items-center">
                <div>
                    <md-button class="md-icon-button md-raised md-danger" @click="deleteProduct">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'trash']" />
                    </md-button>
                    <md-tooltip md-direction="top">Supprimer</md-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "ProductRow",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        product: Object,
        products: Array,
        deviceId: Number,
        errors: Array,
        index: Number,
    },
    data() {
        return {
            selectedProduct: null,
            quantity: null
        }
    },
    methods: {
        async deleteProduct() {
            if(this.product.id) {
                try {
                    await this.$store.dispatch('devices/deleteDeviceProduct', {
                        deviceId: this.deviceId,
                        product_id: this.product.id
                    })
                    await this.$store.dispatch('alerts/success', 'Produit supprimé du dispositif')
                    this.$emit('deleted')
                } catch (e) {
                }
            } else {
                this.$emit('remove', this.product)
            }
        },
        setup() {
            if(this.product.id) {
                this.selectedProduct = this.product
                this.quantity = this.product.pivot.quantity
            }
        },
    },
    mounted() {
        this.setup()
    },
    watch: {
        selectedProduct(newVal) {
            if(newVal) {
                this.product.newId = newVal.id
            }
        },
        quantity(newVal) {
            if(newVal) {
                this.product.newQuantity = parseInt(newVal)
            }
        },
        errors(newVal) {
            this.resetApiValidation()
            if(newVal) {
                let errors = []
                newVal.map(error => {
                    let parts = error.source.pointer.split('.')
                    if(this.index === parseInt(parts[3])) {
                        errors.push({
                            source: { pointer: '/data/attributes/' + parts[4] },
                            detail: error.detail
                        })
                    }
                })
                this.setApiValidation(errors)
            }
        }
    }
}
</script>

<style scoped>

</style>
